import { CheckCircleOutlined } from '@ant-design/icons';
import { Button, Flex, Space, Tag, Typography } from 'antd';
import { SortOrder } from 'antd/es/table/interface';
import Link from 'antd/es/typography/Link';

import placeholderImage from '@/lib/assets/placeholder.jpg';
import { formatNumber } from '@/lib/helpers/formatNumber';
import { formatSecondsToTime } from '@/lib/helpers/formatSecondsToTime';
import getPlatformFromUrl from '@/lib/helpers/getPlatformFromUrl';
import prepareDate from '@/lib/helpers/prepareDate';
import prepareImageSrc from '@/lib/helpers/prepareImageSrc';
import { ISingleMonitorHistoryItem } from '@/ts';

import Platforms from '../../creators/platforms';
import ThumbnailImage from '../../video-insights-co-pilot/ThumbnailImage';

const singleMonitorListColumns = [
	{
		title: 'Date/time',
		dataIndex: 'date_processed',
		key: 'date_processed',
		sorter: true,
		sortDirections: ['ascend', 'descend', 'ascend'] as SortOrder[],
		width: 120,
		// flex: true,
		// ellipsis: true,
		// hidden: true,
		render: (_: any, record: ISingleMonitorHistoryItem) => {
			return (
				<>
					{record?.date_processed
						? prepareDate('' + record?.date_processed)
						: 'no date'}
				</>
			);
		},
	},
	{
		title: 'Video',
		dataIndex: 'content',
		key: 'content',
		// sorter: true,
		ellipsis: true,
		width: 300,
		flex: true,
		render: (_: any, record: ISingleMonitorHistoryItem) => {
			const metaData = record?.content?.metaData || {};
			const preparedTitle =
				(metaData?.title || metaData?.description)?.length > 90
					? (metaData?.title || metaData?.description).slice(0, 90) + '...'
					: metaData?.title || metaData?.description;

			return (
				<Space size={[8, 1]}>
					<ThumbnailImage
						src={
							metaData?.thumbnail
								? prepareImageSrc(metaData?.thumbnail)
								: undefined
						}
						placeholderImage={placeholderImage}
					/>
					<Link href={metaData?.url} ellipsis target="_blank">
						{preparedTitle || metaData?.url}
					</Link>
				</Space>
			);
		},
	},
	{
		title: 'Platform / Creator',
		dataIndex: 'platform',
		key: 'platform',
		// sorter: true,
		elipsis: true,
		width: 150,
		// flex: true,
		// hidden: true,
		render: (_: any, record: ISingleMonitorHistoryItem) => {
			const creator = record?.content?.creator || null;
			const platformHandle =
				creator?.platformHandles?.[1] || creator?.platformHandles?.[0] || '';
			const platform = getPlatformFromUrl(platformHandle || '');

			return (
				<Flex justify="flex-start" align="center" gap={8}>
					<Platforms platform={platform?.name || ''} />

					{platformHandle ? (
						<Button
							type="link"
							href={platformHandle}
							target="_blank"
							style={{
								width: 'fit-content',
								display: 'flex',
								wordWrap: 'break-word',
								overflow: 'hidden',
								padding: 0,
							}}
						>
							<span
								style={{
									width: '100%',
									display: 'inline-block',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								{creator?.profileName}
							</span>
						</Button>
					) : (
						<>
							{creator?.profileName ? (
								<Typography.Text
									style={{
										width: 'auto',
										display: 'inline-block',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
									}}
								>
									{creator?.profileName}
								</Typography.Text>
							) : null}
						</>
					)}
				</Flex>
			);
		},
	},
	{
		title: 'Match found',
		dataIndex: 'match_found',
		key: 'match_found',
		// sorter: true,
		sortDirections: ['ascend', 'descend', 'ascend'] as SortOrder[],
		width: 70,
		// flex: true,
		// ellipsis: true,
		// hidden: true,
		render: (_: any, record: ISingleMonitorHistoryItem) => {
			return (
				<Flex justify="center" align="center">
					{record?.match_found ? (
						<CheckCircleOutlined style={{ color: 'rgb(88, 198, 34)' }} />
					) : (
						<Typography.Text type="secondary">-</Typography.Text>
					)}
				</Flex>
			);
		},
	},
];

export { singleMonitorListColumns };
